// extracted by mini-css-extract-plugin
module.exports = {"input":"styles__input___EF89k","link":"styles__link___3lOZh"};